var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3186 31.6815L16.2277 34.7724L29.3641 48.6815L65.6823 10.8178V3.86328L29.3641 41.7269L19.3186 31.6815Z",
    fill: "#82D66D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6368 35.5451C55.6368 34.4954 55.5714 33.461 55.4444 32.4457L59.4056 28.4313C59.9723 30.7091 60.2732 33.0919 60.2732 35.5451C60.2732 51.7622 47.1266 64.9087 30.9095 64.9087C14.6924 64.9087 1.5459 51.7622 1.5459 35.5451C1.5459 19.328 14.6924 6.18146 30.9095 6.18146C37.4322 6.18146 43.4581 8.3082 48.3317 11.9061L45.0351 15.247C41.0307 12.4551 36.1613 10.8178 30.9095 10.8178C17.253 10.8178 6.18226 21.8886 6.18226 35.5451C6.18226 49.2016 17.253 60.2724 30.9095 60.2724C44.566 60.2724 55.6368 49.2016 55.6368 35.5451Z",
    fill: "#82D66D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.2e415b0e.svg";
export { ForwardRef as ReactComponent };